/* eslint-disable angular/document-service */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Component, Input, OnInit, Renderer2 } from '@angular/core'
import { Router } from '@angular/router'
import * as AdminLte from 'admin-lte'
import * as $ from 'jquery'
import { Session } from 'src/app/Shared/session'

@Component({
  selector: 'app-menu-crm-comercial',
  templateUrl: './menu-crm-comercial.component.html',
  styleUrls: ['./menu-crm-comercial.component.scss']
})
export class MenuCrmComercialComponent implements OnInit {
  public sidebarMenuOpened = true
  session: Session

  constructor(private router: Router, private renderer: Renderer2) {}

  @Input('userName') UserNameToShow: string

  ngOnInit() {
    this.session = Session.getInstance()
    if (this.session.getToken() != undefined) {
      this.session.setMenu(true)
      this.session.setMenuApi(false)
    } else {
      this.session.clear()
    }
  }

  crmContatos() {
    this.session.setConfig(false)
    this.session.setMenuApi(false)
    this.router.navigate(['/iepro-crm/contatos'])
  }
  gerenciamentoComercial() {
    this.session.setConfig(false)
    this.session.setMenuApi(false)
    this.router.navigate(['/iepro-crm/gerenciamento-comercial'])
  }

  homeNavigate() {
    this.router.navigate([''])
  }

  ngAfterViewInit() {
    $('[data-widget="treeview"]').each(function () {
      AdminLte.Treeview._jQueryInterface.call($(this), 'init')
    })
  }

  toggleMenuSidebar() {
    if (this.sidebarMenuOpened) {
      this.renderer.removeClass(
        document.querySelector('app-root'),
        'sidebar-open'
      )
      this.renderer.addClass(
        document.querySelector('app-root'),
        'sidebar-collapse'
      )
      this.sidebarMenuOpened = false
    } else {
      this.renderer.removeClass(
        document.querySelector('app-root'),
        'sidebar-collapse'
      )
      this.renderer.addClass(document.querySelector('app-root'), 'sidebar-open')
      this.sidebarMenuOpened = true
    }
  }
}
